<template>
  <div class="complaints">
    <!-- 投诉 -->
    <el-dialog
      title="投诉"
      :visible.sync="complaintshow"
      width="30%"
      class="complaint"
    >
      <div>
        <div class="two_label">
          <div class="type_name"><span class="xing">*</span>投诉内容</div>
          <div class="type_content">
            <el-input
              v-model="complaintContent"
              placeholder="请输入投诉内容"
              type="textarea"
            ></el-input>
          </div>
        </div>
        <div class="two_label">
          <div class="type_name"><span class="xing">*</span>投诉师傅</div>
          <div class="type_content">
            <a-switch :disabled="status=='RECEIVING_ORDER'" checkedChildren="是" unCheckedChildren="关" v-model="defaultChecked" />
          </div>
        </div>
        <div class="complaint-img">
          <div class="complaint-title">相关图片</div>
          <a-upload
            :action="baseApl + '/common/common/upload_file'"
            listType="picture-card"
            :fileList="fileList"
            @change="handleChange"
          >
            <div v-if="fileList.length < 8">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelComplaint()">取 消</el-button>
        <el-button type="primary" @click="submitComplaint()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "comComplaint",
  props: {
    complaint: Boolean,
    orderNo: String,
    status:String
  },
  data() {
    return {
      fileList: [],
      complaintContent: "",
      baseApl: process.env.VUE_APP_BASE_API,
      defaultChecked:false
    };
  },
  computed: {
    complaintshow: {
      get() {
        return this.complaint;
      },
      set() {
        this.cancelComplaint();
      }
    }
  },
  methods: {
    // 投诉拍照
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    // 取消投诉
    cancelComplaint() {
      this.$emit("showComplaint", false);
    },
    // 提交投诉
    submitComplaint() {
      this.$message.closeAll()
      if (this.complaintContent == "") {
        this.$message.error("请先填写投诉内容");
        return;
      }
      let imgs = this.fileList.map(i => i.response.data.url).join("|");
      this.$post(`/order/api/complaint/add_complaint/${this.orderNo}?content=${this.complaintContent}&picUrls=${imgs}&complaintObject=${this.defaultChecked?0:1}`, {
        content: this.complaintContent,
        picUrls: imgs,
        complaintObject:this.defaultChecked?0:1
      }).then(res => {
        if (res.code == 0) {
          this.complaintContent="";
          this.fileList=[];
          this.cancelComplaint();
          this.$message({
          message: '投诉成功',
          type: 'success'
        });
        } else {
          this.$message(res.message);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.complaints{
  & /deep/ .ant-switch-checked{
    background-color: #3455D3;
  }
}
</style>